export default __webpack_public_path__ + "static/media/chat-bubble-outline-selected.1c345487.svg";